import getCdnIcon from '@/shared/cdn/getCdnIcon';
import Img from '@/shared/components/Img';

const currenciesWithIcons = [
  'BRL',
  'INR',
  'TRY',
  'EUR',
  'JPY',
  'SOC',
  'ETH',
  'LTC',
  'TRX',
  'XRP',
  'USDT',
  'ADA',
];

type Props = { currency?: string; size?: 'sm' | 'md' | 'lg' };

const getDimensions = (size: 'sm' | 'md' | 'lg') => {
  switch (size) {
    case 'sm':
      return { width: 16, height: 16, className: '' };
    case 'md':
      return { width: 20, height: 20, className: 'm-0' };
    case 'lg':
      return { width: 24, height: 24, className: '-m-0.5' };
    default:
      return { width: 16, height: 16, className: '' };
  }
};

const CurrencyIcon: FC<Props> = ({ currency = '', size = 'sm' }) => {
  const { width, height, className } = getDimensions(size);

  if (currenciesWithIcons.includes(currency)) {
    return (
      <Img
        src={getCdnIcon(`currencies/${currency}`)}
        width={width}
        height={height}
        alt={currency}
      />
    );
  }

  switch (currency) {
    case 'mBTC':
    case 'uBTC':
      return (
        <Img
          src={getCdnIcon('bitcoin')}
          width={width}
          height={height}
          alt={currency}
          className={className}
        />
      );
    default:
      if (size === 'sm') {
        return (
          <span className="text-xs">{currency.length ? currency : '—'}</span>
        );
      }
      if (size === 'md') {
        return (
          <span className="text-xs">{currency.length ? currency : '—'}</span>
        );
      }
      return <div className="w-6 h-6" />;
  }
};

export default CurrencyIcon;
